import React from 'react';
import styles from './Graph-Tabs.module.scss';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import DietaryIntakeComponent from './Dietary-Intake/Dietary-Intake';
import ExerciseComponent from './Exercise/Exercise';
import BloodGlucoseComponent from './Blood-Glucose/Blood-Glucose';
import BloodPressureComponent from './Blood-Pressure/Blood-Pressure';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function GraphTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
        <AppBar position="static" className={`${styles.tabsMainDiv} ${styles.helpDiv}`}>
            <Tabs
            variant="fullWidth"
            value={value}
            onChange={handleChange}
            aria-label="nav tabs example"
            >
            <LinkTab label="Dietary Intake" {...a11yProps(0)} />
            <LinkTab label="Exercise" {...a11yProps(1)} />
            <LinkTab label="Blood Glucose" {...a11yProps(2)} />
            <LinkTab label="Blood Pressure" {...a11yProps(3)} />
            </Tabs>
        </AppBar>

        <TabPanel className={`graphChartBody`} value={value} index={0}>
            <DietaryIntakeComponent />
        </TabPanel>

        <TabPanel className={`graphChartBody`} value={value} index={1}>
            <ExerciseComponent />
        </TabPanel>

        <TabPanel className={`graphChartBody`} value={value} index={2}>
            <BloodGlucoseComponent />
        </TabPanel>

        <TabPanel className={`graphChartBody`} value={value} index={3}>
            <BloodPressureComponent />
        </TabPanel>
    </div>
  );
}